var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan-ticket-detail__list-table"},[_c('div',{staticClass:"scan-ticket-detail__table"},[_c('span',{staticClass:"scan-ticket-detail__table-title"},[_vm._v(_vm._s(_vm.getTranslatedText('ticket')))]),_c('div',{attrs:{"id":"lottoIframe"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }